// extracted by mini-css-extract-plugin
export var container = "_gj-1";
export var cornerButtonContainer = "_gj-6";
export var disabled = "_gj-2";
export var dragActive = "_gj-3";
export var fileContainer = "_gj-5";
export var hiddenInput = "_gj-4";
export var widthContainer = "_gj-0";